import { render, staticRenderFns } from "./AboutAs.vue?vue&type=template&id=11d85cb2&scoped=true&"
import script from "./AboutAs.vue?vue&type=script&lang=js&"
export * from "./AboutAs.vue?vue&type=script&lang=js&"
import style0 from "./AboutAs.vue?vue&type=style&index=0&id=11d85cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d85cb2",
  null
  
)

export default component.exports